/* Claude modifications -5l: point the "Available at Amazon" button at the Amazon page for the colour the
   shopper picked. Links per colour come from Theme settings > Amazon links by colour (see
   snippets/fg-amazon-link-attrs.liquid); colours without their own link keep the product's main link. */
(function () {
  function setLink(button, variantId) {
    if (!button) return;
    var map = {};
    try { map = JSON.parse(button.getAttribute('data-amazon-variants') || '{}'); } catch (e) {}
    button.href = map[String(variantId)] || button.getAttribute('data-amazon-default') || button.href;
  }

  document.addEventListener('change', function (event) {
    // Home page product cards: the colour <select class="variant_selector"> holds the variant id
    var select = event.target.closest && event.target.closest('.variant_selector');
    if (select) {
      var card = select.closest('li') || select.closest('.grid__item');
      setLink(card && card.querySelector('.fg-amazon-button[data-amazon-variants]'), select.value);
      // -6: the card photo opens the product page on the chosen colour
      var photoLink = card && card.querySelector('.fg-card-image-link');
      if (photoLink) photoLink.href = photoLink.getAttribute('data-product-url') + '?variant=' + select.value;
      return;
    }
    // Product page: the theme updates the form's hidden variant id after a colour change
    if (event.target.closest && event.target.closest('variant-radios, variant-selects')) {
      setTimeout(function () {
        var input = document.querySelector('product-form input[name="id"]');
        if (!input) return;
        document.querySelectorAll('.fg-amazon-button--product[data-amazon-variants]').forEach(function (button) {
          setLink(button, input.value);
        });
        // -5v: Amazon rating line follows the colour too ("rating|count" per variant id)
        document.querySelectorAll('[data-fg-rating]').forEach(function (line) {
          var map = {};
          try { map = JSON.parse(line.getAttribute('data-fg-rating') || '{}'); } catch (e) {}
          var entry = map[String(input.value)];
          if (!entry) { line.hidden = true; return; }
          var parts = entry.split('|');
          line.hidden = false;
          line.querySelectorAll('[data-fg-rating-value]').forEach(function (el) { el.textContent = parts[0]; });
          line.querySelectorAll('[data-fg-rating-count]').forEach(function (el) { el.textContent = parts[1]; });
          var fill = line.querySelector('[data-fg-rating-fill]');
          if (fill) fill.style.width = (parseFloat(parts[0]) * 20) + '%';
        });
      }, 0);
    }
  });
})();
